module.exports = __webpack_public_path__ + "media/images/sp/stores/kyoto/kyoto_sns_03-d7178061ac3405f7c291fa48a1d28ec2.jpg";